
import { combineReducers } from "redux";
import { ModalPopupReducer } from "../Reducers/ModalPopUpReducer";
import CommonMastersReducer from "../Reducers/CommonMastersReducer";
import { loaderReducer } from "../Reducers/LoginReducer";


const rootReducer = combineReducers({
  loaderReducer,
  modalState: ModalPopupReducer,
  commonMastersReducer: CommonMastersReducer,
});
export default rootReducer;
